import { ReactComponent as IconWarning } from "assets/images/icons/warning-filled.svg";
import { ReactComponent as IconError } from "assets/images/icons/error-filled.svg";
import PropTypes from 'prop-types';
import Trans from "features/translation/components/Trans";
import "./Alert.scss";

const Alert = ({ title, message, type }) => {
  const typeModifier = type && 'alert--' + type;

  let icon;
  switch (type) {
    case 'error':
      message = message || <Trans text="Mogelijk is dit probleem over een paar minuten verholpen. Probeer het opnieuw of neem contact op met de ledenservice als het probleem blijft bestaan."/>;
      icon = <IconError/>;
      break

    case 'success':
      icon = null;
      break

    default:
      title = title || <Trans text="Let op!"/>;
      icon = <IconWarning/>;
  }

  return (
    <div className={ `alert ${ typeModifier }` }>
      { icon }
      <div>
        { title && <div className={ 'bold' }>{ title }</div> }
        { message }
      </div>
    </div>
  )
}

Alert.defaultProps = {
  type: 'error'
}


Alert.propTypes = {
  title: PropTypes.string,
  message: PropTypes.node,
  type: PropTypes.string
}

export default Alert;
